export default {
  isAuthenticated: state => !!state.token,
  isAdmin: state => state.userInfo.role === 1,
  userPhoneNumber: state => state.userInfo.phone,
  isUserCompany: state => state.userCompanies.length > 0,
  isAuthorAdvert: state => id =>
    state.userAdverts.find(advert => parseInt(advert.id) === parseInt(id)) !==
    undefined
}
